import React from "react";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import Tab4 from "./Tab4";

const ResumeSection = ({ color }) => {
    const [openTab, setOpenTab] = React.useState(1);
    return (
        <div className="max-w-7xl mx-auto px-6 pt-20">
            <div className='text-center mb-20'>
                <h3 className="text-xs md:text-sm xl:text-md font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">3+ YEARS OF EXPERIENCE</h3>
                <h1 className='text-5xl md:text-6xl xl:text-7xl font-bold'>My Resume</h1>
            </div>
            <>
                <div className="md:flex md:flex-wrap mx-5">
                    <div className="w-full">
                        <ul
                            className="md:flex mb-0 list-none md:flex-wrap pt-3 pb-4 flex-row "
                            role="tablist"
                        >
                            <li className="-mb-px my-2 mr-2 last:mr-0 md:flex-auto text-center">
                                <a
                                    className={
                                        "text-lg hover:text-[#ff014f] tracking-widest font-semibold  shadow-slate-600 rounded-lg  uppercase px-5 py-8 shadow-lg block leading-normal " +
                                        (openTab === 1
                                            ? "text-[#ff014f] bg-" + color + "-600"
                                            : "text-[#C4CFDE]" + color + "-600 bg-[#202327]")
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(1);
                                    }}
                                    data-toggle="tab"
                                    href="#link1"
                                    role="tablist"
                                >
                                    Education
                                </a>
                            </li>
                            <li className="-mb-px my-2 mr-2 last:mr-0 flex-auto text-center">
                                <a
                                    className={
                                        "text-lg hover:text-[#ff014f] tracking-widest font-semibold  shadow-slate-600 rounded-lg shadow-lg uppercase px-5 py-8 block leading-normal " +
                                        (openTab === 2
                                            ? "text-[#ff014f] bg-" + color + "-600"
                                            : "text-[#C4CFDE]" + color + "-600 bg-[#202327]")
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(2);
                                    }}
                                    data-toggle="tab"
                                    href="#link2"
                                    role="tablist"
                                >
                                    Professional Skills
                                </a>
                            </li>
                            <li className="-mb-px my-2 mr-2 last:mr-0 flex-auto text-center">
                                <a
                                    className={
                                        "text-lg hover:text-[#ff014f] tracking-widest font-semibold  shadow-slate-600 rounded-lg shadow-lg uppercase px-5 py-8 block leading-normal " +
                                        (openTab === 3
                                            ? "text-[#ff014f] bg-" + color + "-600"
                                            : "text-[#C4CFDE]" + color + "-600 bg-[#202327]")
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(3);
                                    }}
                                    data-toggle="tab"
                                    href="#link3"
                                    role="tablist"
                                >
                                    Experience
                                </a>
                            </li>
                            <li className="-mb-px my-2 mr-2  flex-auto text-center">
                                <a
                                    className={
                                        "text-lg hover:text-[#ff014f] tracking-widest font-semibold  shadow-slate-600 rounded-lg shadow-lg uppercase px-5 py-8  block leading-normal " +
                                        (openTab === 4
                                            ? "text-[#ff014f] bg-" + color + "-600"
                                            : "text-[#C4CFDE]" + color + "-600 bg-[#202327]")
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(4);
                                    }}
                                    data-toggle="tab"
                                    href="#link4"
                                    role="tablist"
                                >
                                    Interview
                                </a>
                            </li>
                        </ul>

                        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded">
                            <div className="px-4 py-5 flex-auto">
                                <div className="tab-content tab-space">
                                    <div className={openTab === 1 ? "block" : "hidden"} id="link1">
                                        <Tab1></Tab1>
                                    </div>
                                    <div className={openTab === 2 ? "block" : "hidden"} id="link2">
                                        <Tab2></Tab2>
                                    </div>
                                    <div className={openTab === 3 ? "block" : "hidden"} id="link3">
                                        <Tab3></Tab3>
                                    </div>
                                    <div className={openTab === 4 ? "block" : "hidden"} id="link4">
                                        <Tab4></Tab4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>

            <div className="divider mt-20"></div>
        </div>
    );
};

export default ResumeSection;